import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getOrder } from "../api/order";

const ORDER_TYPE_LABEL = { DELIVERY: "배송", PICKUP: "픽업", DINE_IN: "매장이용" };

export default function OrderDetailPage() {
  const { orderGroupId } = useParams();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getOrder(orderGroupId)
      .then((res) => {
        if (res.success) setOrder(res.data);
        else setError(res.message || "주문을 찾을 수 없습니다.");
      })
      .catch((err) => setError(err.response?.data?.message || "주문을 불러오지 못했습니다."));
  }, [orderGroupId]);

  if (error) return <div className="page"><p className="error">{error}</p></div>;
  if (!order) return <div className="page"><p className="text-sub">불러오는 중...</p></div>;

  return (
    <div className="page">
      <h1 className="page-title">주문 상세</h1>
      <div className="order-summary-card">
        <p>주문번호 <strong>{order.orderGroupId}</strong></p>
        <p>주문상태 {order.orderStatus}</p>
        <p>수령인 {order.receiverName} ({order.receiverPhone})</p>
        <p>수령방법 {ORDER_TYPE_LABEL[order.orderType] || "배송"}</p>
        {order.orderType === "PICKUP" || order.orderType === "DINE_IN" ? (
          <p>이용매장 {order.storeName}</p>
        ) : (
          <p>배송지 {order.receiverAddress}</p>
        )}
        {order.discountAmount > 0 ? (
          <>
            <p>상품금액 {Number(order.originalAmount).toLocaleString()}원</p>
            <p>주문할인{order.discountName ? ` (${order.discountName})` : ""} -{Number(order.discountAmount).toLocaleString()}원</p>
            <p>결제금액 <strong>{Number(order.totalAmount).toLocaleString()}원</strong></p>
          </>
        ) : (
          <p>결제금액 {Number(order.totalAmount).toLocaleString()}원</p>
        )}
      </div>
      <div className="cart-item-list">
        {(order.items || []).map((line) => (
          <div className="cart-item" key={line.orderId}>
            <div className="cart-item-info">
              <div className="cart-item-name">{line.productName}</div>
              <div className="text-sub">{line.optionName} x {line.orderQty}</div>
            </div>
            <div className="cart-item-line-total">{Number(line.orderAmount).toLocaleString()}원</div>
          </div>
        ))}
      </div>
    </div>
  );
}
